import Mission from "@modules/common/icons/mission";
import Vision from "@modules/common/icons/vision";
import { useMediaQuery } from "@mui/material";
import { useInView } from "framer-motion";
import { FC, useRef } from "react";
import { IconProps } from "types/icon";
import { useTranslation } from "@i18n";

function VisionAndMission({
  vision,
  mission,
}: {
  vision: string;
  mission: string;
}) {
  const { t } = useTranslation();
  void vision;
  void mission;
  const Card = ({
    title,
    description,
    Icon,
  }: {
    title: string;
    description: string;
    Icon: FC<IconProps>;
  }) => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    const ref = useRef(null);
    const isInView = useInView(ref, {
      once: false,
      margin: isMobile ? "50% 0px -30% 0px" : "50% 0px -40% 0px",
    });

    return (
      <div
        ref={ref}
        className={`group md:min-h-60 md:w-1/2 border-[1px] rounded-3xl border-primary md:p-10  p-4 
          ${isInView ? "md:bg-green" : "bg-green"} 
          ${
            isInView
              ? "md:bg-primary md:bg-opacity-15"
              : "bg-primary bg-opacity-15"
          }  
          ${isInView ? "md:text-primary" : "text-primary"} 
          md:hover:text-terryWhite md:hover:bg-primary 
          ${isInView && "max-md:text-terryWhite max-md:bg-primary"} 
          transition-all duration-100 overflow-clip`}
      >
        <h1
          className={`text-4xl md:text-5xl font-medium flex justify-between 
          md:translate-y-60 md:group-hover:translate-y-0 
          ${isInView ? "max-md:translate-y-0" : "max-md:translate-y-[14rem]"} 
          transition-all duration-300`}
        >
          {title}{" "}
          <Icon
            className="md:h-[60px] md:w-[60px] h-[40px] w-[40px]"
            size="inherit"
          />
        </h1>
        <p
          className={`md:mt-20 mt-8 text-lg md:text-2xl 
          md:translate-y-60 md:group-hover:translate-y-0 
          ${isInView ? "max-md:translate-y-0" : "max-md:translate-y-60"} 
          transition-all duration-500`}
        >
          {description}
        </p>
      </div>
    );
  };
  return (
    <div className="flex md:pt-40 pt-28 gap-6 relative md:flex-row flex-col justify-center">
      <Card
        title={t.about.vision}
        description={t.about.visionBody}
        Icon={Vision}
      />
      <Card
        title={t.about.mission}
        description={t.about.missionBody}
        Icon={Mission}
      />
    </div>
  );
}

export default VisionAndMission;
